import {WHITE} from '../../globalVariables/GlobalVariables';

function AccessibilityOutline({color = WHITE}: {color?: string}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 22"
            fill="none"
            stroke={color}
            strokeWidth={1}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g transform="translate(5.5,2.292) scale(0.919,1.117)">
                <path d="M0.500056 0.500056L1.74856 10.0701C1.76465 10.1944 1.80607 10.3141 1.87028 10.4218C1.93448 10.5295 2.02009 10.6229 2.12181 10.6962C2.22354 10.7694 2.33922 10.8211 2.4617 10.8479C2.58418 10.8747 2.71085 10.8761 2.83389 10.852C4.75706 10.4752 8.96364 9.66672 9.66672 9.66672C10.5834 9.66672 11.0417 14.7084 11.5001 14.7084C12.1238 14.6116 12.7375 14.4582 13.3334 14.2501" />
            </g>
            <g transform="translate(3.667,0.458) scale(0.833)">
                <path d="M5.50133 2.99975C5.50152 3.49437 5.35501 3.97794 5.08034 4.3893C4.80568 4.80065 4.41519 5.12131 3.95827 5.31072C3.50135 5.50013 2.99852 5.54978 2.51337 5.4534C2.02823 5.35701 1.58257 5.11892 1.23275 4.76923C0.882938 4.41954 0.644681 3.97397 0.548118 3.48886C0.451555 3.00375 0.501023 2.50091 0.690265 2.04391C0.879508 1.58692 1.20002 1.19632 1.61128 0.921502C2.02253 0.646685 2.50604 0.5 3.00067 0.5C3.66373 0.5 4.29964 0.763336 4.76858 1.2321C5.23752 1.70087 5.50109 2.33669 5.50133 2.99975Z" />
            </g>
            <g transform="translate(2.75,11.51) scale(0.826,0.857)">
                <path d="M4.52327 0.50011C3.38958 0.758767 2.37606 1.39173 1.64615 2.29693C0.916242 3.20212 0.512493 4.32678 0.500016 5.48953C0.496717 6.81186 1.01429 8.0823 1.9407 9.02587C2.86712 9.96944 4.12785 10.5102 5.45002 10.5312C6.79147 10.5175 8.07548 9.98475 9.03259 9.04474C9.9897 8.10472 10.5455 6.83052 10.5833 5.48953V4.06961" />
            </g>
            <g transform="translate(6.774,10.083) scale(0.844,1.86)">
                <path d="M0.50012 1.92737L6.10187 0.50012" />
            </g>
        </svg>
    );
}

export default AccessibilityOutline;
